import React, {memo, useCallback, useEffect, useMemo, useState} from 'react';
import {PasswordContainer} from '../../../../../components/PasswordContainer';
import {SettingsPageContainer} from '../../../../../components/Settings/SettingsPageContainer';
import {useHistory, useParams} from 'react-router-dom';
import {useKeyboard} from '../../../../../hooks/keyboard';
import {SettingInputComponent} from '../../../../../components/Settings/SettingInputComponent';
import {SettingReadOnlyRowComponent} from '../../../../../components/Settings/SettingReadOnlyRowComponent';
import {useMessage} from '../../../../../hooks/message';
import {useRPC} from '../../../../../hooks/rpc';
import {useSetSelector} from '../../../../../hooks/set-selector';
import {useLocalization} from "../../../../../hooks/localization";
import { useDispatch, useSelector } from 'react-redux';
import { setConnectedWifiAction } from '../../../../../store/settings/actions';

let timeout;
export const WiFiConnectScreen = memo(function WiFiConnectScreen() {
    const {t} = useLocalization();
    const params = useParams<{ gatewayId: string; id: string; }>();
    const {success, failure, loading} = useMessage();
    const history = useHistory();
    const [rpc] = useRPC();
    const [setActiveInput, renderKeyboard, currentInput] = useKeyboard();
    const dispatch = useDispatch();
    const selectedWifi = useSelector(state => state.settings.connectedWifi)


    const [password, setPassword] = useState('');
    const [wifiNetworkName, setWiFiNetworkName] = useState('');
    const [isManuel, setManuel] = useState(false);
    const [gatewayId, setGatewayId] = useState(null);

    const gatewaySet = useSetSelector(state => state.control.gatewayList);
    const gatewayName = useMemo(() => gatewayId == null ? null : gatewaySet[gatewayId].name,
        [gatewayId, gatewaySet]);

    const BACK_URL = useMemo(() => {
        return `/settings/gateway/${params.gatewayId != null ? params.gatewayId : ""}/wifi`
    }, [params])

    const onBackPressed = useCallback(() => {
        history.push(BACK_URL);
    }, [BACK_URL, history]);


    const isConnectFieldsValid = useCallback(() => {
        if (wifiNetworkName == null || wifiNetworkName.length === 0) {
            failure(t('pls_enter_a_valid_network_name'));

            return false;
        }

        if (password == null || password.length === 0) {
            failure(t('pls_enter_a_valid_password'));

            return false;
        }

        return true;
    }, [t, failure, wifiNetworkName, password]);

    const onConnectPress = useCallback(() => {
        if (!isConnectFieldsValid()) {
            return;
        }
        loading(t('wifi_connecting'), false)
        rpc.connectWifiNetwork(gatewayId, wifiNetworkName, password)
            .then(() => {
                timeout = setTimeout(() => {
                    dispatch(setConnectedWifiAction(''))
                    onBackPressed()
                    success(t("connected"))
                }, 4000)
                return () => clearTimeout(timeout)
            })
            .catch(failure);
    }, [t, failure, dispatch, gatewayId, isConnectFieldsValid, onBackPressed, password, rpc, success, wifiNetworkName, loading]);

    const onBlur = useCallback(() => {
        setActiveInput(null);
    }, [setActiveInput]);

    const buttons = useMemo(() => [
        {
            text: t('connect'),
            className: 'green',
            onClick: onConnectPress,
        },
        {
            text: t('cancel'),
            className: 'red',
            url: BACK_URL,
        },
    ], [t, BACK_URL, onConnectPress]);

    useEffect(() => {
        setGatewayId(params.gatewayId);

        if (params.id !== 'connect-manuel') {
            setWiFiNetworkName(selectedWifi)
        } else {
            setManuel(true);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <PasswordContainer requiredRole='admin' isFullscreen={true}>
            <SettingsPageContainer
                buttons={buttons}
                className='service-edit'
                backUrl={BACK_URL}
                currentInput={currentInput}
                title={gatewayName || ''}>
                <div className='content-divider'>
                    <div className='content-wrapper'>
                        {
                            renderIf(isManuel)(() =>

                                    <SettingInputComponent
                                        placeholder={t('write_network_name')}
                                        label={t('network_name')}
                                        value={wifiNetworkName}
                                        setValue={setWiFiNetworkName}
                                        setActiveInput={setActiveInput}
                                        onBlur={onBlur}/>,
                                () =>

                                    <SettingReadOnlyRowComponent
                                        title={t('wifi_name')}
                                        value={selectedWifi}/>,
                            )
                        }
                        <SettingInputComponent
                            type='password'
                            placeholder={t('write_password')}
                            label={t('password')}
                            value={password}
                            setValue={setPassword}
                            setActiveInput={setActiveInput}
                            onBlur={onBlur}/>
                    </div>
                    <div className='content-wrapper'>

                    </div>
                </div>
            </SettingsPageContainer>
            {
                renderKeyboard()
            }
        </PasswordContainer>
    );
});
